module.exports = __webpack_public_path__ + "img/teachingmanagement_3.1dadb452.jpg";